//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { events, util } from "@nuskin/ns-util";
import {
  AccountManager,
  UserService,
  VGDistInfoService
} from "@nuskin/ns-account";
import { CurrencyService } from "@nuskin/ns-shop";
import webLoyalty from "@nuskin/ns-loyalty-web";
import { NsIcon } from "@nuskin/design-components";
import { isNullOrEmpty } from "@nuskin/ns-common-lib";

import vueEventBus from "./EventBus";

export default {
  name: "NsHeaderProfile",
  components: {
    NsIcon
  },
  props: {
    /**
     * Hides the Signup text and link
     */
    hideSignUp: Boolean,

    /**
     * Overrides service call for market loyalty data
     * ({ enabled, landingPage, dashboardPage })
     */
    marketLoyalty: {
      type: Object,
      default: null
    },

    /**
     * List of potential navigation links
     */
    profileMenu: {
      type: Array,
      default: () => []
    },

    /**
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },

    /**
     * The url where signup link takes you
     */
    signUpUrl: {
      type: String,
      default: ""
    },

    /**
     * Translations for component
     * Required keys: id, enjoyLoyalty, newCustomerLabel,
     * signUpTodayLabel, signIn, signOut, signUp
     */
    translations: {
      type: Object,
      default: () => ({})
    },

    /**
     * Overrides service call for user loyalty data ({ optedIn, wallet: {} })
     */
    userLoyalty: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      marketLoyaltyFromService: {
        enabled: false,
        landingPage: "",
        dashboardPage: ""
      },
      preferredName: "",
      isLoggedIn: false,
      user: null,
      userLoyaltyFromService: {
        optedIn: false,
        wallet: {
          available: null
        }
      },
      userVolumes: []
    };
  },
  computed: {
    desktop() {
      return this.$mq === "desktop" || this.$mq === "desktopHD";
    },

    runConfig() {
      return this.$NsAppService.runConfig || {};
    },

    marketConfig() {
      return this.$NsAppService.marketConfig || {};
    },

    filteredProfileMenu() {
      return this.profileMenu.filter(pm =>
        pm.accountLevels.some(
          al => this.isLoggedIn && !!this.user && this.user.accountType === al
        )
      );
    },

    isInUserMarket() {
      return (
        this.isLoggedIn &&
        !!this.user &&
        !!this.runConfig &&
        this.user.countryCd === this.runConfig.country
      );
    },

    _marketLoyalty() {
      return this.marketLoyalty || this.marketLoyaltyFromService;
    },

    _userLoyalty() {
      return this.userLoyalty || this.userLoyaltyFromService;
    },

    loyaltyAmount() {
      return CurrencyService.format(this._userLoyalty.wallet.available);
    },

    rewardsPageUrl() {
      const language = this.runConfig.language || "en";
      const market = this.runConfig.country || "US";
      const localeCode = `${language}_${market}`;

      let url = this.showPoints
        ? this._marketLoyalty.dashboardPage
        : this._marketLoyalty.landingPage;
      return url.replace("{locale}", localeCode);
    },

    showDistPhotoNameId() {
      return (
        this.isLoggedIn &&
        !!this.user &&
        (this.user.accountType === "10" ||
          (util.countryCode === "JP" && this.user.accountType === "30"))
      );
    },

    showPoints() {
      return (
        this.isInUserMarket &&
        this._userLoyalty.optedIn &&
        !!this._userLoyalty.wallet.available
      );
    },

    showVolumes() {
      return (
        this.isLoggedIn &&
        !!this.user &&
        this.user.accountType === "10" &&
        this.userVolumes &&
        this.userVolumes.length > 0
      );
    },

    username() {
      return (
        this.preferredName ||
        (this.isLoggedIn &&
          !!this.user &&
          (this.user.displayName ||
            this.user.localName ||
            this.user.lastName + ", " + this.user.firstName))
      );
    },
    isGuest() {
      return !!this.user && !!this.user.isGuest;
    }
  },
  mounted() {
    this.addListeners();
  },
  destroyed() {
    this.removeListeners();
  },
  methods: {
    init() {
      this.setUser();

      // if userLoyalty is not provided in props, call service
      if (
        !this.userLoyalty ||
        (this.userLoyalty.optedIn && !this.marketLoyalty)
      ) {
        this.getLoyaltyData();
      }
    },

    handleSignIn() {
      events.publish(events.authentication.REQUEST_FOR_LOGIN, {
        href: window.location.href
      });
    },

    handleSignOut(event) {
      event.preventDefault();
      const signOutUrl =
        this.signOutUrl === "#"
          ? util.getLocaleUrl() + "home.html"
          : this.signOutUrl;
      AccountManager.afterLogoutRedirect = signOutUrl;
      AccountManager.logout();
    },

    getLoyaltyData() {
      if (!this.marketLoyalty) {
        this.marketLoyaltyFromService = this.marketConfig.loyalty || {
          enabled: false,
          landingPage: "",
          dashboardPage: ""
        };
      }

      if (this._marketLoyalty.enabled && !this.userLoyalty) {
        this.getUserLoyaltyValues();
      }
    },

    getUserLoyaltyValues() {
      const userLoyaltyData = webLoyalty.getLoyaltyRewardsPoints();

      if (userLoyaltyData && userLoyaltyData.optInStatus) {
        this.userLoyaltyFromService = {
          optedIn: true,
          wallet: {
            available: userLoyaltyData.wallet.available
          }
        };
      }
    },

    setUser() {
      this.isLoggedIn = UserService.isLoggedIn();
      if (this.isLoggedIn) {
        this.user = UserService.getUser();
        this.setUserProfileImageNameAndVolumes();
      } else {
        this.user = null;
      }
    },

    async setUserProfileImageNameAndVolumes() {
      if (
        this.isLoggedIn &&
        !!this.user &&
        (!this.user.photoURL || !this.user.displayName || !this.user.volumes) &&
        !this.user.isVolumesLoaded
      ) {
        const distInfo = await VGDistInfoService.getVGDistInformation();

        if (distInfo) {
          if (distInfo.photoURL && !this.user.photoURL) {
            this.user = {
              ...this.user,
              photoURL: distInfo.photoURL
            };
          }

          if (distInfo.displayName && !this.user.displayName) {
            this.user = {
              ...this.user,
              displayName: distInfo.displayName
            };
          }
        }
      }

      this.setUserVolumes();

      if (isNullOrEmpty(this.userVolumes)) {
        // checkVolumeData fires the VOLUME_ADDED and LOGIN_COMPLETE events
        await VGDistInfoService.checkVolumeData();
      }
    },

    setUserVolumes() {
      if (this.isLoggedIn && !!this.user && !!this.user.volumes) {
        if (Array.isArray(this.user.volumes)) {
          this.userVolumes = this.user.volumes;
        } else {
          this.userVolumes = Object.entries(this.user.volumes).map(
            ([key, value]) => ({
              name: key,
              value
            })
          );
        }
      } else {
        this.userVolumes = [];
      }
    },

    handleUserChange() {
      this.setUser();
    },

    handleProfileImageUpdate(profileImageUrl) {
      this.user = {
        ...this.user,
        photoURL: profileImageUrl
      };
    },

    handlePreferredNameUpdate(preferredName) {
      this.preferredName = preferredName;
    },

    handleVolumesAdded(user) {
      this.user = {
        ...this.user,
        ...user
      };

      this.setUserVolumes();
    },

    handleLoyaltyDataUpdate() {
      this.getUserLoyaltyValues();
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      // watch app service to finish loading
      this.$watch(
        function() {
          return !this.$NsAppService.loading;
        },
        this.init,
        {
          immediate: true
        }
      );

      // listen to config changes
      vueEventBus.$on("config-changed", this.setUser);

      // listen to auth (login/logout) changes
      events.subscribe(events.authentication.LOGIN, this.handleUserChange);
      events.subscribe(events.authentication.LOGOUT, this.handleUserChange);

      // listen to profile image updates
      events.subscribe(
        events.account.PROFILE_IMAGE_UPDATED,
        this.handleProfileImageUpdate
      );

      // listen to preferred name updates
      events.subscribe(
        events.account.PREFERRED_NAME_UPDATE,
        this.handlePreferredNameUpdate
      );

      // listen to volumes being added
      events.subscribe(events.account.VOLUME_ADDED, this.handleVolumesAdded);

      // listen to loyalty updates if userLoyalty is not provided in props
      if (!this.userLoyalty) {
        events.subscribe(
          events.loyalty.LOYALTY_DATA_UPDATED,
          this.handleLoyaltyDataUpdate
        );
      }
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to event bus
      vueEventBus.$off();

      // stop listening to auth changes
      events.unsubscribe(events.authentication.LOGIN, this.updateUser);
      events.unsubscribe(events.authentication.LOGOUT, this.updateUser);

      // stop listening to profile image updates
      events.unsubscribe(
        events.account.PROFILE_IMAGE_UPDATED,
        this.handleProfileImageUpdate
      );

      // stop listening to preferred name updates
      events.unsubscribe(
        events.account.PREFERRED_NAME_UPDATE,
        this.handlePreferredNameUpdate
      );

      // stop listening to volumes being added
      events.unsubscribe(events.account.VOLUME_ADDED, this.handleVolumesAdded);

      // stop listening to loyalty updates
      events.unsubscribe(
        events.loyalty.LOYALTY_DATA_UPDATED,
        this.handleLoyaltyDataUpdate
      );
    }
  }
};
